export default {
  data() {
    return {
      breadcrumb: [{ label: "Quản lí CPDs", path: "/cpds" }],
      checkedlist: [],
      positions: [],
      filter: {
        q: "",
        per_page: 50,
        page: 1,
        id: '',
        brand: null,
        partner: null,
        user: null,
        display: [],
        active: [1],
        expired: []
      },
      result: null,
      lockedMessage: "",
      crudOptions: {
        size: "xl",
      },
      externalDomain: process.env.VUE_APP_EXTERNAL_DOMAIN,
      crudForm: this.defaultCrudForm(),
      crudtab: "info",
      domains: [],
      imageTab: "mobile",
      exportResult: null,
      isSearching: false,
      team: null,
      history: {
        total_cost: 0,
        total_discount: 0,
        item: null,
        logs: []
      }
    };
  },

  computed: {
    master() {
      return this.$store.state.master;
    },

    user() {
      return this.$store.state.auth.user;
    },

    pages() {
      return this.$store.state.auth.pages;
    },

    canNext() {
      return this.crudForm.brand_name;
    },

    availableImage(){
      let tab = '';

      if (this.imageTab == 'mobile') tab = 'pc';
      else tab = 'mobile';

      if (this.crudForm.content[tab]) return {
        type: tab,
        content: this.crudForm.content[tab]
      };

      return;
    },

    trackingQueryPlaceholder() {
      if (this.crudForm.external_key) {
        for (let i = 0; i < this.domains.length; i++) {
          if (this.domains[i].key == this.crudForm.external_key) {
            if (this.domains[i].name.includes('?')) {
              return this.domains[i].name.split('?')[1];
            }
  
            break;
          }
        }
      }

      return 'name=value&key=test';
    },

    countFilter(){
      let count = 0;

      if (this.filter.display.length > 0) count++;
      if (this.filter.active.length > 0) count++;
      if (this.filter.brand) count++;
      if (this.filter.partner) count++;
      if (this.filter.user) count++;
      if (this.filter.expired.length > 0) count++;

      return count;
    },

    tags(){
      if (!this.master || !this.crudForm.partner_name || !this.master.cpd.tags[this.crudForm.partner_name]) return [];
      let tags = this.master.cpd.tags[this.crudForm.partner_name];
      return tags;
    }
  },

  methods: {
    getEmbedCode(items){
      let rs = {};

      items.forEach(item => {
        item.tags.forEach(tag => {  
          rs[tag] = rs[tag] || {
            tab: 'script',
            tabs: ['script', 'iframe'],
            iframe: {},
            script: {
              links: [],
              position: []
            }
          }

          if (!rs[tag].script.links.includes(item.team_id + '-' + tag)) rs[tag].script.links.push(item.team_id + '-' + tag);
          if(!rs[tag].iframe[item.position]) rs[tag].iframe[item.position] = item.team_id + '-' + tag + '/' + item.position;
          if(!rs[tag].script.position.includes(item.position)) rs[tag].script.position.push(item.position);
        });
      });

      return rs;
    },

    formatDatePicker(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();

      return (
        year +
        "-" +
        ("0" + month).slice(-2) +
        "-" +
        ("0" + day).slice(-2) +
        " " +
        ("0" + hour).slice(-2) +
        ":" +
        ("0" + minute).slice(-2) +
        ":" +
        ("0" + second).slice(-2)
      );
    },

    checkall() {
      if (this.checkedlist.length == this.result.data.length)
        this.checkedlist = [];
      else this.checkedlist = this.result.data.map((item) => item.id);
    },

    toggleCheckbox(id) {
      if (this.checkedlist.includes(id))
        this.checkedlist.splice(this.checkedlist.indexOf(id), 1);
      else this.checkedlist.push(id);
    },

    defaultCrudForm(data) {
      data = data || {};

      return {
        id: data.id || 0,
        tags: data.tags || [],
        partner_name: data.partner_name || '',
        partner_domains: data.partner_domains || [],
        name: data.name || "",
        cost: data.cost || 0,
        discount: data.discount || 0,
        start_at: data.start_at || "",
        end_at: data.end_at || "",
        from: data.from || "",
        to: data.to || "",
        content_type: data.content_type || "image",
        content: data.content || {},
        brand_name: data.brand_name || "",
        brand_type: data.brand_type || "",
        external_key: data.external_key || "",
        tracking_query: data.tracking_query || "",
        position: data.position || "",
        note: data.note || "",
        // user_id: '',
        // team_id: '',
        errors: {},
      };
    },

    async search() {
      this.checkedlist = [];
      this.isSearching = true;
      let filter = {...this.filter};
      filter.display = filter.display.join(',');
      filter.active = filter.active.join(',');
      filter.expired = filter.expired.join(',');
      let res = await this.$api.cpd.search(filter).call();
      this.isSearching = false;

      if (res.success) {
        this.result = res.response.result;
      }
    },

    resetFilter(){
      this.filter = {
        ...this.filter,
        brand: null,
        partner: null,
        user: null,
        display: [],
        active: [1],
        expired: []
      };
      this.onChangePage(1);
    },

    onChangeFilter(name, e, options){
      if (name == 'display') {
        let isCheck = e.target.checked;

        if (isCheck) {
          this.filter.display.push(options);
        } else {
          this.filter.display.splice(this.filter.display.indexOf(options), 1);
        }
      }

      if (name == 'active') {
        let isCheck = e.target.checked;

        if (isCheck) {
          this.filter.active.push(options);
        } else {
          this.filter.active.splice(this.filter.active.indexOf(options), 1);
        }
      }

      if (name == 'expired') {
        let isCheck = e.target.checked;

        if (isCheck) {
          this.filter.expired.push(options);
        } else {
          this.filter.expired.splice(this.filter.expired.indexOf(options), 1);
        }
      }

      this.onChangePage(1);
    },

    openModalCreate() {
      this.crudtab = "info";
      this.crudForm = this.defaultCrudForm();
      this.team = this.user.team;
      this.onChangeBrand(false);
      this.$refs.crudModal.show();
    },

    openModalUpdate(data) {
      data = JSON.parse(JSON.stringify(data));
      this.crudtab = "info";
      this.crudForm = this.defaultCrudForm(data);
      this.team = data.team;
      this.onChangeBrand(false);
      if (this.crudForm.content.mobile) this.imageTab = "mobile";
      else if (this.crudForm.content.pc) this.imageTab = "pc";
      else this.imageTab = "mobile";
      this.getPositions();
      this.$refs.crudModal.show();
    },

    getBrandInfo(name) {
      let filter = this.master.brands.filter((item) => item.name === name);
      return filter[0];
    },

    getPositions() {
      let pos = [];
      if (this.master && this.crudForm.partner_name && this.crudForm.tags.length > 0) {
        this.crudForm.tags.forEach((item) => {
          if (this.master.cpd.positions[this.crudForm.partner_name][item]) {
            pos = pos.concat(this.master.cpd.positions[this.crudForm.partner_name][item]);
          }
        });
      };

      this.positions = pos.filter((value, index, self) => {
        return self.indexOf(value) === index
      });
    },

    async onSaveCrud(isEx) {
      let req;
      let data = { ...this.crudForm };
      data.start_at = data.start_at ? this.formatDatePicker(new Date(data.start_at)) : '';
      data.end_at = data.end_at ? this.formatDatePicker(new Date(data.end_at)) : '';
      delete data.errors;
      let brand = this.getBrandInfo(data.brand_name);
      data.brand_type = brand.type;
      data.brand_code = brand.code;

      if (data.id) req = this.$api.cpd.update(data);
      else req = this.$api.cpd.create(data);
      let res = await req.call();

      if (res.success) {
        this.search();
        this.$refs.crudModal.hide();
        if (isEx) this.onRender([res.response.result]);
        else this.onRender(false);
      } else {
        if (res?.response?.result?.errors) {
          this.crudForm.errors = res.response.result.errors;
          this.crudtab = "info";
        }
      }
    },

    onChangePage(page) {
      this.filter.page = page;
      this.search();
    },

    onChangeTags(field, tags) {
      this.crudForm[field] = tags;
    },

    async onChangeBrand(reset) {
      if (reset) this.crudForm.external_key = "";
      if (!this.team) return;

      let filter = {
        brand: this.crudForm.brand_name,
        team: this.team.code
      };

      let res = await this.$api.config
        .externalDomains(filter)
        .call();

      if (res.success) {
        this.domains = res.response.result;
      }
    },

    /**
     * Upload file to server when input file is changed
     */
    async onUploadFile() {
      let form = new FormData();
      form.append("file", this.$refs.file.files[0]);
      form.append("brand_name", this.crudForm.brand_name);
      let res = await this.$api.file.upload(form).call();

      if (res.success) {
        this.crudForm.content[this.imageTab] = {
          id: res.response.result.id,
          minetype: res.response.result.minetype,
          src: res.response.result.url,
          size: res.response.result.size,
        };
      }
    },

    async onOpenFile() {
      this.$refs.file.value = "";
      this.$refs.file.click();
    },

    decodeQuery(queryString) {
      var query = {};
      var pairs = queryString.split('&');
      for (var i = 0; i < pairs.length; i++) {
          var pair = pairs[i].split('=');
          query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
      }
      return query;
    },

    encodeQuery(query) {
      let ls = [];
      for (let key in query) {
        if (query[key]) ls.push(key + '=' + query[key]);
      }

      return ls.join('&');
    },

    async openAdsReview() {
      let url = "";

      for (let i = 0; i < this.domains.length; i++) {
        if (this.domains[i].key == this.crudForm.external_key) {
          if (!this.crudForm.tracking_query) {
            url = this.domains[i].name;
            break;
          }

          if (this.domains[i].name.includes('?')) {
            let ex = this.domains[i].name.split('?');
            let query = {
              ...this.decodeQuery(ex[1]),
              ...this.decodeQuery(this.crudForm.tracking_query)
            };

            url = ex[0] + '?' + this.encodeQuery(query);
          } else {
            url = this.domains[i].name + (this.crudForm.tracking_query ? '?' + this.crudForm.tracking_query : '');
          }

          break;
        }
      }

      let a = document.createElement("a");
      a.setAttribute("target", "_blank");
      a.setAttribute("href", url.includes("http") ? url : "https://" + url);
      a.click();
    },

    async onRender(filter) {
      let res = await this.$api.cpd
        .render()
        .call();
      if (res.success) {
        if (filter === undefined) this.exportResult = res.response.result;
        else if (filter === false) {
          this.$store.dispatch('toast/show', {
            data: {message: 'Đã build bản mới thành công.'},
            variant: 'success',
            delay: 2000
          });
          return;
        }
        else {
          let rs = this.getEmbedCode(filter);
          this.exportResult = rs;
        }
        this.$refs.exportModal.show();
      }
    },

    async onRemoveImage() {
      delete this.crudForm.content[this.imageTab];
    },

    async onDelete() {
      this.$store.dispatch("confirmation/open", {
        title: "Xác nhận",
        type: 'confirmation',
        message: "Bạn thực sự muốn xóa "+this.checkedlist.length+" CPD được chọn?",
        options: [
          {
            name: "cancel",
            label: "Hủy",
            variant: "secondary",
          },
          {
            name: "delete",
            label: "Xóa",
            variant: "danger"
          },
        ],
        events: {
          confirm: async (name) => {
            if (name == 'delete') {
              let res = await this.$api.cpd.delete({id: this.checkedlist}).call();

              if (res.success) {
                this.checkedlist = [];
                this.search();
              }
            }
          }
        }
      });
    },

    async onActive(status) {
      let res = await this.$api.cpd.active({id: this.checkedlist, status}).call();

      if (res.success) {
        this.onRender(false);
        this.result.data.forEach((item, index) => {
          if (this.checkedlist.includes(item.id)) {
            this.result.data[index].active = status;
          }
        });
      }
    },

    async onToggleDisplay(item){
      let status = item.display ? 0 : 1;
      let res = await this.$api.cpd.display({id: item.id, status}).call();

      if (res.success) {
        item.display = status;
        this.onRender(false);
      }
    },

    onCopyToLipboard(e){
      let text = this.$refs[e].innerText.replace(/^\s+|\s+$/g, '');
      navigator.clipboard.writeText(text);
      this.$store.dispatch('toast/show', {
        data: {message: 'Đã sao chép nội dung.'},
        variant: 'success',
        delay: 2000
      });
    },

    openModalEmbed(items){
      if (!items) items = this.result.data.filter(item => {
        return this.checkedlist.includes(item.id);
      });
      let rs = this.getEmbedCode(items);
      this.exportResult = rs;
      this.$refs.exportModal.show();
    },

    useImage(content){
      this.crudForm.content[this.imageTab] = content;
    },

    onClone(item){
      let data = JSON.parse(JSON.stringify(item));
      data.id = 0;
      data.content = {};
      this.crudtab = "info";
      this.crudForm = this.defaultCrudForm(data);
      this.team = this.user.team;
      this.onChangeBrand(false);
      this.$refs.crudModal.show();
    },

    async onNewRef(item, i){
      this.$store.dispatch("confirmation/open", {
        title: "Xác nhận",
        type: 'confirmation',
        message: 'Bạn thực sự muốn tạo ref mới cho CPD này?<div>Vui lòng đọc tài liệu về ref trước khi thực hiện điều này.</div><div><i class="bx bx-right-arrow-alt"></i> <a target="_blank" href="/docs/ref">Tài liệu về ref</a></div>',
        options: [
          {
            name: "cancel",
            label: "Hủy",
            variant: "secondary",
          },
          {
            name: "ok",
            label: "OK",
            variant: "primary"
          },
        ],
        events: {
          confirm: async (name) => {
            if (name == 'ok') {
              let rs = await this.$api.cpd.createRef({id: item.ref || item.id}).call();
              if (rs.success) {
                this.$store.dispatch('toast/show', {
                  data: {message: 'Đã tạo ref mới cho CPD.'},
                  variant: 'success',
                  delay: 2000
                });
                this.result.data[i] = rs.response.result;
                this.openModalUpdate(this.result.data[i]);
              }
            }
          }
        }
      });
    },

    async openHistory(item){
      let rs = await this.$api.cpd.history({
        ref: item.ref
      }).call();

      if (rs.success) {
        this.history.logs = rs.response.result;
        this.history.item = item;
        this.history.total_cost = 0;
        this.history.total_discount = 0;
        this.history.logs.forEach((log) => {
          this.history.total_cost += parseFloat(log.cost);
          this.history.total_discount += parseFloat(log.discount);
        });
        this.$refs.historyModal.show();
      }
    },

    onAddMultiSelect(name, item){
      let newMaster = {...this.master};

      if (name == 'partner') {
        if (this.master.cpd.partners.includes(item)) return;
        newMaster.cpd.partners.push(item);
        this.$store.commit('master', newMaster);
      }
      
      if (name == 'tags') {
        if (this.tags.includes(item)) return;
        newMaster.cpd.tags[this.crudForm.partner_name] = newMaster.cpd.tags[this.crudForm.partner_name] || [];
        newMaster.cpd.tags[this.crudForm.partner_name].push(item);
        this.$store.commit('master', newMaster);
      }

      if (name == 'position') {
        if (this.positions.includes(item)) return;
        this.positions.push(item);
      }
    },

    changeMul(name){
      if (name == 'partner') {
        this.crudForm.tags = [];
        this.crudForm.position = null;
      }

      if (name == 'tags') {
        this.crudForm.position = null;
      }

      this.getPositions();
    }
  },

  async mounted() {
    if (this.$route.query.id) {
      this.filter.id = this.$route.query.id;
    }
    
    await this.search();
    this.filter.id = '';
  },
};
